const apiUrl = process.env.REACT_APP_API_URL;
const baseUrlApi = apiUrl;
const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL;
const TERMS_AND_CONDITIONS_URL = process.env.REACT_APP_TERMS_AND_CONDITIONS_URL;
const ABOUT_US = process.env.REACT_APP_ABOUT_US;

let ApiConfig = {
  token: null,
  TERMS_AND_CONDITIONS_URL,
  ABOUT_US,
  BASE_IMAGE_URL,

  // AUTH
  login: `${baseUrlApi}user/login`,
  signUp: `${baseUrlApi}user/signup`,
  socialSignUp: `${baseUrlApi}user/social-signup`,
  otpVerify: `${baseUrlApi}user/otp/verify`,
  resendOtp: `${baseUrlApi}user/resend-otp`,
  forgotPassword: `${baseUrlApi}user/forgot-web-password`,
  changePassword: `${baseUrlApi}user/change-web-password`,

  // USER Detail
  userDetails: `${baseUrlApi}user/details`,
  onBoardingStatus: `${baseUrlApi}user/updateOnboarding`,
  updateProfile: `${baseUrlApi}user/updateprofile`,
  changeUserAvatar: `${baseUrlApi}user/upload-image`,

  // Home Category
  homeCategory: `${baseUrlApi}categories`,

  // FeedBack
  feedBack: `${baseUrlApi}user/feedback`,
  purchaseToken: `${baseUrlApi}user/orders`,

  // Chats
  getChat: `${baseUrlApi}user/messagelist`, // for message list
  sendMessage: `${baseUrlApi}chat/reply/first`, // for message list
  messageAction: `${baseUrlApi}user/`, // for message Action like, dislike, translate
  historyList: `${baseUrlApi}user/savedmessage-list`, // for history list
  deleteAccount: `${baseUrlApi}user/deleteaccount`, //for deleting current account
  checkredability: `${baseUrlApi}user/checkredability`, // for redability score 
  //SUBSCRIPTION
  subscription: `${baseUrlApi}user/orders`,
  subscriptionplan: `${baseUrlApi}user/subscription-plan`,
  paymentDetail: `${baseUrlApi}user/payment`
};

export default ApiConfig;

